import create from 'zustand';

interface MetricSidebarStore {
  sidebarInfo: any;
  openSidebar: (info: any) => void;
  closeSidebar: () => void;
}

export const useMetricSidebarStore = create<MetricSidebarStore>((set) => ({
  sidebarInfo: {
    isOpen: false,
    metric: '',
    title: '',
    data: null,
    startDate: '',
    endDate: '',
    sprintId: '',
    author: '',
    teamId: '',
    view: '',
    type: '',
    subTitle: '',
  },
  openSidebar: (info: any) => set({ sidebarInfo: { ...info, isOpen: true } }),
  closeSidebar: () =>
    set((state: any) => ({
      sidebarInfo: { ...state.sidebarInfo, isOpen: false },
    })),
}));
